const TYPE_SELL = 'SELL';
const TYPE_DEBT_SELL = 'DEBT_SELL';
const TYPE_PURCHASE = 'PURCHASE';
const TYPE_RETURN_SELL = 'RETURN_SELL';
const TYPE_RETURN_PURCHASE = 'RETURN_PURCHASE';
const TYPE_CHANGES_IN = 'CHANGES_IN';
const TYPE_CHANGES_OUT = 'CHANGES_OUT';
const TYPE_MOVING = 'MOVING';
const TYPE_CHANGES_INVENTORY = 'CHANGES_INVENTORY';
const BASE_PRICE = 'base_price';
const PURCHASE_PRICE = 'purchase';

export {
  TYPE_SELL,
  TYPE_DEBT_SELL,
  TYPE_PURCHASE,
  TYPE_RETURN_SELL,
  TYPE_RETURN_PURCHASE,
  TYPE_CHANGES_IN,
  TYPE_CHANGES_OUT,
  TYPE_MOVING,
  TYPE_CHANGES_INVENTORY,
  BASE_PRICE,
  PURCHASE_PRICE
}



// WEBPACK FOOTER //
// ./src/apps/product_order/const.js